import ActionMenu from "../../../../components/actionMenu/ActionMenu";
import { useAppDispatch } from "../../../../redux/hooks";
import { setClientSelectedWorkingPoint } from "../../../../redux/reducer/expedition.reducer";

function ClientWorkingPointsActionButton({ crudData }: any) {
  const dispatch = useAppDispatch();

  const handleButtonPress = () => {
    dispatch(setClientSelectedWorkingPoint(crudData));
  };

  return (
    <ActionMenu
      items={[
        {
          id: "associate-working-point",
          label: "Asociere punct lucru",
          icon: "WORKING_POINT",
          tooltip: "Deschide asocierea acestui punct de lucru cu clientul.",
          onClick: handleButtonPress,
        },
      ]}
      title={crudData?.denumire}
      ariaLabel={`Actiuni pentru punctul de lucru ${crudData?.denumire ?? ""}`}
    />
  );
}

export default ClientWorkingPointsActionButton;
